import React from 'react'

const LoadingContext = React.createContext({ isLoading: {}, setValue: () => { }, incrementLoading: () => { }, decrementLoading: () => { } });

export default LoadingContext;